import React from "react";
import About from "../Components/About/About";
import Layout from "./Layout";

export default function Panel() {
  return (
    <Layout>
      <section className="h-auto mx-auto max-w-screen-xl px-4 w-full my-6">
        <About />
      </section>
    </Layout>
  );
}
